import {Box, Text} from '@chakra-ui/react'
import React, {useEffect, useState} from 'react'
import {useRouter} from '../../../_app/hooks/useRouter'
import ImageHelper from '../../../helpers/ImageHelper/ImageHelper'
import Image from 'next/legacy/image'
import BreakpointsHelper from '../../../helpers/BreakpointsHelper/BreakpointsHelper'

const PostThumbnail = ({
    post,
    cover_image,
    category,
    title,
    url_key,
  }: any) => {
    const { locale } = useRouter()
    const style = {
        anchor: {
            width: '100%',
        },
        box: {
            position: 'relative',
        }
    }
    const [isImageValid, setIsImageValid] = useState(false)
    useEffect(() => {
        ImageHelper.checkImage(post?.image || cover_image?.data?.attributes?.url, (isValid: boolean | ((prevState: boolean) => boolean)) => {
            setIsImageValid(isValid)
        })
    }, [cover_image])
    return (
        <a href={`/${locale}/blog/${post?.url_key || url_key}.html`} style={style.anchor}>
            <Box w="full" cursor="pointer">
                <Image
                    src={isImageValid ? post?.image || cover_image?.data?.attributes?.url : '/images/blog.jpg'}
                    alt={post?.image || title}
                    height={BreakpointsHelper.isMobile() ? 300 : 230}
                    width={500}
                    style={{
                        width: '100%',
                        objectFit: 'cover',
                    }}
                />
                <Box sx={style.box}>
                    {
                        category && (
                            <Box
                                position="absolute"
                                left="15px"
                                bottom="14px"
                                bg="veryLightPink"
                                padding="6px 12px"
                            >
                                <Text textTransform="uppercase" fontSize="12px">
                                    {category}
                                </Text>
                            </Box>
                        )
                    }
                </Box>
                <Text textStyle="h4" fontWeight={500} mt="16px">
                    {post?.name || title}
                </Text>
            </Box>
        </a>
    )
}

export default PostThumbnail
